const MOST_READ_ENDPOINT = '/api/most-read?limit=8';

function cleanText(value) {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

function cleanUrl(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';

  try {
    const url = new URL(raw, window.location.origin);
    if (!['http:', 'https:'].includes(url.protocol)) return '';
    return url.toString();
  } catch {
    return '';
  }
}

function createMostReadCard(item) {
  const article = document.createElement('article');
  article.className = 'wla-home-most-read-card';

  const rank = Math.max(1, Math.round(Number(item.rank || 0)));
  const href = cleanUrl(item.url);
  const title = cleanText(item.title);
  const excerpt = cleanText(item.excerpt);
  const imageUrl = cleanUrl(item.imageUrl);
  if (!href || !title) return null;

  const imageLink = document.createElement('a');
  imageLink.className = imageUrl ? 'wla-home-most-read-card__image' : 'wla-home-most-read-card__image is-empty';
  imageLink.href = href;
  imageLink.setAttribute('aria-label', title);
  decorateTrackedLink(imageLink, item, rank);

  if (imageUrl) {
    const image = document.createElement('img');
    image.src = imageUrl;
    image.alt = '';
    image.loading = 'lazy';
    image.decoding = 'async';
    imageLink.append(image);
  } else {
    const placeholder = document.createElement('span');
    placeholder.textContent = 'We❤️Apple';
    imageLink.append(placeholder);
  }

  const body = document.createElement('div');
  body.className = 'wla-home-most-read-card__body';

  const meta = document.createElement('span');
  meta.className = 'wla-home-most-read-card__rank';
  meta.textContent = `#${rank}`;

  const heading = document.createElement('h3');
  const headingLink = document.createElement('a');
  headingLink.href = href;
  headingLink.textContent = title;
  decorateTrackedLink(headingLink, item, rank);
  heading.append(headingLink);

  body.append(meta, heading);

  if (excerpt) {
    const paragraph = document.createElement('p');
    paragraph.textContent = excerpt;
    body.append(paragraph);
  }

  article.append(imageLink, body);
  return article;
}

function decorateTrackedLink(link, item, rank) {
  link.dataset.wlaInternalLink = '1';
  link.dataset.wlaInternalModule = 'most-read';
  link.dataset.wlaInternalPlacement = 'home_most_read';
  link.dataset.wlaInternalRank = String(rank);
  link.dataset.wlaInternalAnchor = cleanText(item.title);
}

export async function initMostReadHome() {
  const root = document.querySelector('[data-wla-home-most-read]');
  const list = root?.querySelector('[data-wla-home-most-read-list]');
  if (!root || !list) return;

  try {
    const response = await fetch(MOST_READ_ENDPOINT, {
      headers: { accept: 'application/json' }
    });
    if (!response.ok) return;

    const data = await response.json();
    const trendingUrls = new Set(
      [...document.querySelectorAll('.wla-home-v3__now a[href]')]
        .map((link) => cleanUrl(link.href))
        .filter(Boolean)
    );
    const items = (Array.isArray(data?.items) ? data.items : [])
      .filter((item) => !trendingUrls.has(cleanUrl(item.url)))
      .slice(0, 5);
    const cards = items.map(createMostReadCard).filter(Boolean);
    if (!cards.length) return;

    list.replaceChildren(...cards);
    root.hidden = false;
  } catch {}
}
